import { useEffect, useState } from "react";

import { ActiveFilters } from "../../../../commons/specs/filters";
import { ProductType } from "../../../../commons/specs/product";
import { Brand } from "../../../../commons/types/brand";
import { getSelectedBrands } from "../brand";
import { useBrands } from "../queries/use-brands";

type Params<Type extends ProductType> = {
  activeFilters: ActiveFilters<Type>;
  brandKey?: string;
};

export default <Type extends ProductType>({ activeFilters, brandKey }: Params<Type>) => {
  const { active, activeCount, getBrand } = useBrands();

  const [selectedBrands, setSelectedBrands] = useState<Brand<Type>[]>([]);

  useEffect(() => {
    if (activeCount === 0 && !brandKey) {
      return;
    }

    const selectedBrands = brandKey ? [getBrand(brandKey)] : getSelectedBrands(active ?? [], activeFilters);

    setSelectedBrands(selectedBrands);
  }, [activeFilters, brandKey, active, activeCount, getBrand]);

  return selectedBrands;
};
